export default {
  initialPrompt: `
  Hi there! I'm Opal, Optimizely's AI. Great to meet you! I can help you create content, come up with campaign ideas, generate hypotheses for experiments, and much more. I can also conduct web research, analyze data, summarize documents, and answer your questions about Optimizely products. I have access to a lot of tools to help you get work done, so just try me for anything that comes to mind. Also, if you need help with using Opal, just ask me!\n\nWhat are you working on today?
  `,
  primaryAgentFFKey: 'primary_agent',
};
